module.exports = __webpack_public_path__ + "static/img/antonyleung.a1d8047.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/antonyleung.png
// module id = bBhu
// module chunks = 0